import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { AuthHeaders } from '../../../models/auth-headers';
import { selectData } from '../../../utils/select-data';
import { partnerAccountSchema } from '../schemas/partner-account.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get a list of partner accounts
 * @param applicationName name of the application (Optional)
 * @param partnerId ID of partner (Optional)
 * @returns array of partner accounts
 */
export function getPartnerAccounts(
  this: unknown,
  requestParams?: {
    applicationName?: string;
    partnerId?: string;
  }
) {
  const params = new URLSearchParams();
  if (typeof requestParams?.applicationName === 'string') {
    params.append('applicationName', requestParams.applicationName);
  }
  if (typeof requestParams?.partnerId === 'string') {
    params.append('partnerId', requestParams.partnerId);
  }

  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).partnerAccountsUrl}${
        params.toString() === '' ? params.toString() : `?${params.toString()}`
      }`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(partnerAccountSchema)));
}
